import React, { useState, useEffect } from "react";
import { useNavigate , useLocation, useParams  } from "react-router-dom";
import axios from "axios";
import axiosInstance from "./axiosInstance";
import { Modal, Button } from "react-bootstrap";
//const taxRate = 0.1; // 10%
const discount = 0.0;
const BASE_IMAGE_URL = "http://103.235.105.54/admin/uploads/items/";
const ItemsUpdate = () => {
  const [orderType, setOrderType] = useState("take-away"); 
     const [order, setOrder] = useState(() => {
      const saved = sessionStorage.getItem("order");
      return saved ? JSON.parse(saved) : [];
    });
    const [customer, setCustomer] = useState();
    const [orderTypeValue, setOrderTypeValue] = useState(0);
    const [prevOrder, setPrevOrder] = useState({});
    const [activeCategory, setActiveCategory] = useState("all");
    const [notes, setNotes] = useState("");
    const [error, setError] = useState("");
    const [menuItems, setMenuItems] = useState([]); // ✅ will hold API data
    const [orderText, setOrderText] = useState("Order More");
    const company_id=sessionStorage.getItem("company_id") || 1;
    const branch_id=sessionStorage.getItem("branch_id") || 1;
    const token=sessionStorage.getItem("token");
    const [showVariants, setShowVariants] = useState(false);
    const [selectedVariants, setSelectedVariants] = useState([]);
    const [selectedItemName, setSelectedItemName] = useState("");
    const [tablesData, setTablesData] = useState([]);
  const { order_id } = useParams();
    const [orderId, setOrderId] = useState(null);
      const [orderItems, setOrderItems] = useState([]);
        const [totalAmount, setTotalAmount] = useState(0);
    const [selectedTables, setSelectedTables] = useState([]);
      const [selectedItem, setSelectedItem] = useState(null);
      const [selectedAttribute, setSelectedAttribute] = useState(null);
      const [selectedQty, setSelectedQty] = useState(1);
    const navigate = useNavigate();
    useEffect(() => {
      const savedData = sessionStorage.getItem("orderResponse");
      if (savedData) {
        const data = JSON.parse(savedData);
        console.log("Loaded from session:", data);
  
        if (data.status && data.data.length > 0) {
          const order = data.data[0];
          setOrderId(order.id);
        setCustomer(order.customer_name || "");
          setOrderTypeValue(order.order_type);
  setPrevOrder(data.data[0]);
  setSelectedTables(
  data.data[0].table_id
    ? data.data[0].table_id.split(",").map((id) => id.trim()) // ["4","2"]
    : []
);
  setTotalAmount(order.total_price || 0.00);
          // Format items again
          const formattedItems = order.items.map((item) => {
            let imgSrc = "assets/images/foods/foods.png";
            try {
              if (item.images && item.images !== "") {
                const imgs = JSON.parse(JSON.parse(item.images));
                if (imgs.length > 0) {
                  imgSrc = "http://103.235.105.54/storage/items/" + imgs[0];
                }
              }
            } catch (e) {
              console.warn("Image parse error:", e);
            }
  
            return {
              title: item.item_name,
              baseprice: parseFloat(item.baseprice),
              qty: parseInt(item.qty, 10),
              img: imgSrc,
              tax: parseFloat(item.tax),
            };
          });
  
          setOrderItems(formattedItems);
        }
      }
    }, []);
    // ✅ Load order from sessionStorage when page loads

  useEffect(() => {
      const savedOrder = sessionStorage.getItem("order");
      if (savedOrder) {
        setOrder(JSON.parse(savedOrder));
      }
    }, []);
    useEffect(() => {
      const fetchTables = () => {
        fetch("http://103.235.105.54/admin/api/tables", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            branch_id: sessionStorage.getItem("branch_id"),
            company_id: sessionStorage.getItem("company_id"),
          }),
        })
          .then((res) => res.json())
          .then((data) => {
            console.log("Fetched data:", data);
    
            if (data.status === true && Array.isArray(data.data)) {
              setTablesData(data.data);
    
 
            }
          })
          .catch((err) => console.error("Fetch error:", err));
      };
    
      fetchTables(); // fetch immediately when page loads
    }, []);
  // --- Load saved order and migrate if needed ---
  useEffect(() => {
    const raw = sessionStorage.getItem("order");
    if (!raw) return;

    try {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) {
        setOrder(parsed);
      } else if (parsed && typeof parsed === "object") {
        const converted = Object.entries(parsed).map(([key, item]) => ({
        //  id: item.item_id ? `${item.item_id}-${item.variant_id || 0}` : `${key}`,
          item_id: item.id ||  null,
          item_name: item.item_name || key,
          attribute: item.attribute || item.variant_name || "",
          tax:Number(item.tax ||  0),
          price: Number(item.baseprice || item.price || 0),
          qty: Number(item.qty || 0),
        }));
        setOrder(converted);
      } else {
        setOrder([]);
      }
    } catch (e) {
      console.error("Failed to parse saved order:", e);
      setOrder([]);
    }
  }, []);
  
    // ✅ Save order whenever it changes
    useEffect(() => {
      if (Object.keys(order).length > 0) {
        sessionStorage.setItem("order", JSON.stringify(order));
      }
    }, [order]);
  
    // ✅ Fetch items from API

 useEffect(() => {
    const fetchItems = () => {
      fetch("http://103.235.105.54/admin/api/getitems", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          branch_id: sessionStorage.getItem("branch_id"),
          company_id: sessionStorage.getItem("company_id"),
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.status === "success" && Array.isArray(data.data)) {
            const parsedData = data.data.map((item) => {
              let imgs = item.images;
              try {
                if (typeof imgs === "string") imgs = JSON.parse(imgs);
              } catch {}
              return { ...item, images: imgs || [] };
            });
            setMenuItems(parsedData);
          }
        })
        .catch((err) => console.error("Fetch error:", err));
    };

    fetchItems();
    const interval = setInterval(fetchItems, 10000);
    return () => clearInterval(interval);
  }, []);



    useEffect(() => {
    const savedType = sessionStorage.getItem("orderType");
    if (savedType) {
      setOrderType(savedType); 
    }
  }, []);

  // Handle selection
  const handleSelect = (type) => {
    setOrderType(type);
    sessionStorage.setItem("orderType", type);

    if (type === "dine-in") {
      navigate("/table");
    } else if (type === "take-away") {
      navigate("/item");
    }
  };
    const increaseQty = (item) => {
      setOrder((prev) => {
        const qty = (prev[item.item_name]?.qty || 0) + 1;
         const imgs = parseImages(item.images); // use safe parser
    const imgSrc =
      imgs.length > 0
        ? BASE_IMAGE_URL + imgs[0]
        : "assets/images/foods/foods.png";
        return { ...prev, [item.item_name]: { baseprice: Number(item.baseprice),item_id:item.id, qty:qty ,img:imgSrc,tax:parseFloat(item.baseprice*qty*item.igst_percent)/100} };
      });
    };
  
    const decreaseQty = (item) => {
      setOrder((prev) => {
        const qty = (prev[item.item_name]?.qty || 0) - 1;
        if (qty <= 0) {
          const newOrder = { ...prev };
          delete newOrder[item.item_name];
          return newOrder;
        }
 const imgs = parseImages(item.images); // use safe parser
    const imgSrc =
      imgs.length > 0
        ? BASE_IMAGE_URL + imgs[0]
        : "assets/images/foods/foods.png";
        return { ...prev, [item.item_name]: { baseprice: Number(item.baseprice),item_id:item.id, qty:qty,img:imgSrc,tax:parseFloat(item.baseprice*qty*item.igst_percent)/100 } };
      });
    };
  const handleAddToOrder = () => {
    if (!selectedItem) {
      alert("No item selected.");
      return;
    }
    if (!selectedAttribute) {
      alert("Please select an attribute.");
      return;
    }

   const price = Number(selectedItem.price) || Number(selectedItem.baseprice) || 0;
const igst = Number(selectedItem.igst_percent) || 0;
const vat  = Number(selectedItem.vat_percent) || 0;
const taxp = Number(selectedItem.tax_percent) || 0;

const newEntry = {
  id: `${selectedItem.id}-${selectedAttribute.id}`,
  item_id: selectedItem.id,
  item_name: selectedItem.item_name,
  attribute: selectedAttribute.name,
  images: selectedItem.images,
  percent:parseFloat((igst + vat + taxp) / 100),
  tax: parseFloat(price * (Number(selectedQty) || 1) * (igst + vat + taxp) / 100),
  price,
  qty: Number(selectedQty) || 1,
};
    setOrder((prev) => {
      const idx = prev.findIndex((p) => p.id === newEntry.id);
      if (idx > -1) {
        const copy = [...prev];
        copy[idx] = { ...copy[idx], qty: copy[idx].qty + newEntry.qty };
        return copy;
      }
      return [...prev, newEntry];
    });

    setShowVariants(false);
    setSelectedItem(null);
    setSelectedAttribute(null);
    setSelectedQty(1);
  }; 
  const deleteItem = (id) => {
    setOrder((prev) => prev.filter((o) => o.id !== id));
  };
  
  
    // ✅ Calculate totals
const subtotal = order.reduce((acc, o) => acc + (Number(o.price) || 0) * (Number(o.qty) || 0), 0);

const taxRate = order.reduce((acc, o) => {
  if (!o) return acc; // skip null/undefined
  const tax =  (Number(o.price) || 0) * (Number(o.qty) || 0)*o.percent || 0;
  return acc + tax;
}, 0);
  
  const tax = taxRate;
  const total = subtotal + tax - discount;

  const categories = ["all", ...new Set(menuItems.map((i) => i.subcategory_name))];
  const filteredItems = activeCategory === "all" ? menuItems : menuItems.filter((i) => i.subcategory_name === activeCategory);

  
    // ✅ Handle Pay Now
    const handlePayNow = async(orderId) => {
 try {
      if (!orderId) return;

      const res = await fetch(
        `http://103.235.105.54/admin/api/takeaway-order/${orderId}`
      );
      const data = await res.json();
      console.log("API Response:", data);

      if (data.status && data.data.length > 0) {
        const order = data.data[0];
        

        // Save full response to sessionStorage
        sessionStorage.setItem("orderResponse", JSON.stringify(data));
       navigate(`/payment/${orderId}`);
      }
    } catch (err) {
      console.error("Error fetching order:", err);
    }


      
    };
    const orderTypeMap = {
  "dine-in": 1,
  "takeaway": 2,
  "delivery": 3,
};
 //const order_type = orderTypeMap[orderType] || 0;
const buildOrderPayload = () => {
      const items = order.map((o) => ({
      item_id: o.item_id || (o.id ? Number(String(o.id).split("-")[0]) : null),
      price: o.price,
      qty: o.qty,
      cgst: 0,
      sgst: 0,
      tax: o.tax,
      netprice: (o.price || 0) * (o.qty || 0)+(o.tax),
      attribute: o.attribute || "",
    }));
    return {
    "branch_id": branch_id,
  "company_id": company_id,
  "customer_id": 1,
  "payment_mode": 1,
  // "order_type": order_type,
  "order_type": orderTypeValue, 
  // "table_id": selectedTables.join(", "),
  "table_id": null, 
  "notes": notes.length > 0 ? notes:'Update order with new items',
  "items":items,
  };
};
    const handleOrderNow = async () => {
      if(orderText==='Order More')
      {
         try {
          const finalOrder = buildOrderPayload();
console.log("Final order payload:", finalOrder);
      console.log("ORDER DATA:", finalOrder);
  //const branch_id = sessionStorage.getItem("branch_id") || 1;
  //const company_id = sessionStorage.getItem("company_id") || 1;
  
      const response = await axios.put(
        `http://103.235.105.54/admin/api/updateOrder/${orderId}`,
        finalOrder,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log("Order response:", response.data);
if (response.data.status) {
      setOrderText("Order Placed");
      const order_id=response.data.order_id;
      sessionStorage.setItem("order_id",order_id) ;
      
    sessionStorage.removeItem("order_id"); 
    sessionStorage.removeItem("selectedTables"); 
    sessionStorage.removeItem("orderType"); 
    sessionStorage.removeItem("order"); 

    setOrderType("take-away"); 
    setOrder([]);
    setOrderText("Order More");
    alert("Additional items Order Successfully");
   navigate("/table");   
     // sessionStorage.removeItem("user");
}
else{
  setError("Error, Try Again");
}

    } catch (error) {
      console.error("Error submitting order:", error);
    }
        setOrderText("Order Placed");
      }
       if(orderText==='Order Placed')
      {
       
      }
    };
/*  const parseImages = (images) => {
    try {
      let parsed = JSON.parse(images); // first parse
      if (typeof parsed === "string") {
        // if still a string, parse again
        parsed = JSON.parse(parsed);
      }
      return parsed;
    } catch (e) {
      console.error("Image parse error:", e, images);
      return [];
    }
  };*/
    const parseImages = (images) => {
    if (!images) return [];
    if (Array.isArray(images)) return images;
    try {
      const p = typeof images === "string" ? JSON.parse(images) : images;
      return Array.isArray(p) ? p : [];
    } catch {
      return [];
    }
  };
      const handleCancelNow = () => {
      //navigate("/payment");
    sessionStorage.removeItem("order_id"); 
    sessionStorage.removeItem("selectedTables"); 
    sessionStorage.removeItem("orderType"); 
    //sessionStorage.removeItem("order"); 

   // setSelectedTables([]);
    setOrderType("take-away");
    setOrder([]);
    setOrderText("Order More");
    };
    return (
      <main className="main-wrapper">
        <div className="main-content">

{/* {selectedTables.length === 0 ? (<>
            <div className="d-flex justify-content-center gap-3 mb-4">
          <button
            className={`btn ${
              orderType === "dine-in" ? "btn-primary" : "btn-outline-primary"
            }`}
            onClick={() => handleSelect("dine-in")}
          >
            Dine In
          </button>
          <button
            className={`btn ${
              orderType === "take-away" ? "btn-success" : "btn-outline-success"
            }`}
            onClick={() => handleSelect("take-away")}
          >
            Take Away
          </button>
        </div>
</>):(<></>)} */}


          <div className="container-fluid">
            <div className="menu-wrapper row">
              {/* Menu Items */}
              <div className="col-md-8">
                <div className="row mb-3">
                  <div className="col-lg-12 bg-white">
                    <h6 className="p-3 mb-0">FOOD MENU</h6>
                  </div>
                </div>
  
                {/* Tabs */}
                <ul className="nav nav-tabs" id="menuTabs" role="tablist">
                  {categories.map((cat) => (
                    <li className="nav-item" key={cat}>
                      <button
                        className={`nav-link ${activeCategory === cat ? "active" : ""}`}
                        onClick={() => setActiveCategory(cat)}
                      >
                        {cat.charAt(0).toUpperCase() + cat.slice(1)}
                      </button>
                    </li>
                  ))}
                </ul>
  
                 <div className="row g-3 mt-2">
              {filteredItems.map((item) => {
                const imgs = parseImages(item.images);
                const imgSrc = imgs.length > 0 ? BASE_IMAGE_URL + imgs[0] : "assets/images/foods/foods.png";

                return (
                  <div className="col-md-4" key={item.id}>
                    <div className="menu-card"
                    onClick={() => {
                          setSelectedVariants(item.variants || []);
                          setSelectedItem(item);
                          setSelectedAttribute(null);
                          setSelectedQty(1);
                          setShowVariants(true);
                        }}
                    >
                      <img src={imgSrc} alt={item.item_name} />
                      <h6>{item.item_name}</h6>
                      <div className="price">₹{Number(item.baseprice).toFixed(1)}</div>
                      
                    </div>
                  </div>
                );
              })}
            </div>
              </div>
  
              {/* Order Summary */}

              <div className="col-md-4">
             




                <div className="order-summary">
  {selectedTables.length > 0 && (
 <div className="mb-3">
  <label>Selected Tables:</label>
 
  <div className="d-flex flex-wrap gap-2 mt-2">
    {tablesData
      .filter((t) => selectedTables.includes(String(t.id))) // ✅ check from all floors
      .map((t) => (
        <label
          key={t.id}
          className="border p-2 rounded"
          style={{ cursor: "pointer",backgroundColor:"#8fdce4",fontSize:"12px" }}
        >
          {t.table_code || t.table_name}
        </label>
      ))}
  </div>
</div>
)}  


 <div className="d-flex justify-content-left gap-3 mb-4">
  <h5>
    Customer: {customer ? customer: "Dine-in Customer"}
  </h5>
</div>
{prevOrder.items?.map((item, index) => {
  // Safely parse images
  let imgs = [];
  try {
    //imgs = JSON.parse(JSON.parse(item.images)); // because your API double-encodes
   imgs = parseImages(item.images);
  } catch (e) {
    imgs = []; 
  }

  const imgSrc =
    imgs.length > 0
      ? BASE_IMAGE_URL + imgs[0]
      : "assets/images/foods/foods.png";

  return (
    <div
      key={index}
      className="order-item d-flex justify-content-between align-items-center mb-3"
    >
      <div className="d-flex align-items-center gap-2">
        <img
          src={imgSrc}
          alt={item.item_name}
          style={{ width: "60px", height: "60px", objectFit: "cover" }}
          className="rounded"
        />
        <div>
          <div className="title fw-semibold">{item?.item_name} {item?.attribute}<span style={{fontSize:"9px"}}>( with tax )- </span>{item.netprice}</div>
          <small>
            (₹{item.baseprice}) × {item.qty}
          </small>{" "}
          
          <small>= ₹{(item.baseprice * item.qty).toFixed(2)}</small>
        </div>

      </div>
      <input type="checkbox" defaultChecked  disabled />
    </div>
  );
})}
 <div className="mt-4">
                  <h6 className="fw-bold">Payment Summary</h6>
                  <div className="d-flex justify-content-between">
                    <span>Sum of Item Price</span>
                    <span className="text-primary">₹
                      {prevOrder?.price ? prevOrder.price : "0.00"}
                    
                      </span>
                  </div>
                  <div className="d-flex justify-content-between">
                    <span>Tax</span>
<span className="text-primary">
  ₹{(
    (parseFloat(prevOrder?.cgst) || 0) +
    (parseFloat(prevOrder?.sgst) || 0) +
    (parseFloat(prevOrder?.igst) || 0) +
    (parseFloat(prevOrder?.vat) || 0) +
    (parseFloat(prevOrder?.tax) || 0)
  ).toFixed(2)}
</span>

                  </div>
               <hr />
                  <div className="d-flex justify-content-between">
                    <span>Total</span>
                    <span className="text-primary">
                      {prevOrder?.total_price ? prevOrder.total_price : "0.00"}
                      {/* ₹{totalAmount.toFixed(2)} */}
                      </span>
                  </div>
                  <hr />
                </div>
{order.length === 0?<></>:<>
                  <h5 className="mb-3">Additional Order’s Summary</h5>
                  <hr />
                  <div id="order-items">
                  
  {order.map((o) => (
    <div
      key={o.id}
      className="order-item d-flex justify-content-between align-items-center"
    >
      <span>
        {o.item_name} - {o.attribute} (₹{o.price})
      </span>

      <div className="d-flex align-items-center">
        {/* Quantity controls */}
        <button
          className="btn btn-sm btn-outline-secondary"
          onClick={() =>
            setOrder((prev) =>
              prev.map((item) =>
                item.id === o.id && item.qty > 1
                  ? { ...item, qty: item.qty - 1 }
                  : item
              )
            )
          }
        >
          –
        </button>

        <span className="mx-2">{o.qty}</span>

        <button
          className="btn btn-sm btn-outline-secondary"
          onClick={() =>
            setOrder((prev) =>
              prev.map((item) =>
                item.id === o.id
                  ? { ...item, qty: item.qty + 1 }
                  : item
              )
            )
          }
        >
          +
        </button>

        <span className="ms-3">
          ₹{(o.price * o.qty).toFixed(1)}
        </span>

        <button
          className="btn btn-sm btn-danger ms-2"
          onClick={() => deleteItem(o.id)}
        >
          ✖
        </button>
      </div>
    </div>
  ))}
                </div> 
              
                  <hr />
                  <div className="payment-summary">
                     <div className="d-flex justify-content-between">
                <span>Price</span>
                <span>₹{subtotal.toFixed(1)}</span>
              </div>
              <div className="d-flex justify-content-between">
                <span>Tax</span>
                <span>₹{tax.toFixed(1)}</span>
              </div>
         
              <hr /> 
              <div className="d-flex justify-content-between fw-bold">
                <span>Total</span>
                <span>₹{total.toFixed(1)}</span>
              </div>
              <div className="d-flex justify-content-between fw-bold">
                <span>Grand Total</span>
                <span>
  ₹{(Number(prevOrder?.total_price || 0) + Number(total || 0)).toFixed(1)}
</span>
              </div>
                    {/* <div class="row">
                    <div className="col-md-8"></div>
                      <div className="col-md-4">
                  <div className="d-flex justify-content-between" style={{display:"none"}}>

                      <button className="pay-btn mt-3" onClick={handleCancelNow}>
                    Cancel
                  </button>
                  </div>
                  </div>
                  </div> */}
                  </div><br />
                    </>
}
                  <div className="row">
                  <div className="col-md-12">
                  <textarea style={{width:"100%"}} placeholder="Suggestions"  onChange={(e) => setNotes(e.target.value)}>{notes}</textarea>
                  </div>
                  </div>
                  <div className="row">
                  <div className="col-md-6">
                  <button 
                  onClick={handleOrderNow}
                   disabled={orderText === "Order Placed"} 
                   className={`pay-btn mt-3 
  ${orderText === "Order Placed" ? "bg-gray-400 cursor-not-allowed !important" : "bg-blue-600 hover:bg-blue-700 !important"}
`}
                  >
                    {orderText}
                  </button>
                  </div>
                  <div className="col-md-6">
                  <button className="pay-btn mt-3" 
                  onClick={() => handlePayNow(orderId)}
                  // onClick={handlePayNow}
                  >
                    Pay Now
                  </button>
                  </div>
                  </div>
                  <div className="row">
                  <div className="col-md-6">
                   <p>{error}</p> 
                  </div>
                  </div>
                  
                </div>
              </div>
            </div>
          </div>
        </div>
       <Modal show={showVariants} onHide={() => setShowVariants(false)} centered dialogClassName="custom-modal-width">
           <div className="modal-header">
             <h5 className="modal-title">{selectedItem ? selectedItem.item_name : ""}</h5>
             <button type="button" className="btn-close" onClick={() => setShowVariants(false)} />
           </div>
   
           <div className="modal-body">
             <div className="row">
              {/* <div className="col-md-6">
              {(() => {
       const imgs = parseImages(selectedItem ? selectedItem.images : []);
       const imgSrc =
         imgs.length > 0
           ? BASE_IMAGE_URL + imgs[0]
           : "assets/images/foods/foods.png";
   
       return (
         <div className="quantity-btns d-flex align-items-center mt-3">
           <img
             src={imgSrc}
             alt={selectedItem?.item_name || "Item"}
             className="me-2"
             style={{ width: "150px", height: "150px", objectFit: "cover" }}
           />
         </div>
       );
     })()}
   </div> */}
     <div className="col-md-12">
             {selectedVariants && selectedVariants.length > 0 ? (
               selectedVariants.map((v) => (
                 <div
                   key={v.id}
                   className={`mb-2 p-2 border rounded d-flex justify-content-between ${selectedAttribute?.id === v.id ? "bg-primary text-white" : ""}`}
                   style={{ cursor: "pointer" }}
                   onClick={() => setSelectedAttribute(v)}
                 >
                   <span>{v.name}</span>
                   <span>{v.price ? `₹${v.price}` : ""}</span>
                 </div>
               ))
             ) : (
               <p>No variants available</p>
             )}
             </div>
   </div>
    <div className="row">
     <div className="col-md-3"></div>
              <div className="col-md-5">
             <div className="d-flex align-items-center mt-3">
               <button className="btn btn-sm btn-outline-secondary" onClick={() => setSelectedQty((q) => Math.max(1, q - 1))}>
                 -
               </button>
               <span className="mx-2">{selectedQty}</span>
               <button className="btn btn-sm btn-outline-secondary" onClick={() => setSelectedQty((q) => q + 1)}>
                 +
               </button>
             </div>
   </div>
              <div className="col-md-3">
             <button className="btn btn-success mt-3" onClick={handleAddToOrder}>
               Add
             </button>
   </div>
   </div>
           </div>
         </Modal>
      </main>
    );
  };
export default ItemsUpdate